var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ets-structure',[(_vm.userPermissions)?_c('ets-sidebar',{attrs:{"slot":"sidebar","sections":_vm.sections},slot:"sidebar"}):_vm._e(),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }